import Label from "./Label";
import Input from "./Input";
import { InfoIcon } from "../../icons/CommonIcons";
import { useState } from "react";
import Button from "./Button";

const DataFormField = ({
  divClass,
  labelClass,
  label,
  htmlFor,
  inputProps,
  inputClass = "mt-1 w-full border rounded px-3 py-2",
  error = "",
  formData,
  language = false,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  // 🔹 Helper to render label with required *
  const renderLabel = () => (
    <div className="flex items-center gap-1">
      <Label className={labelClass} htmlFor={htmlFor}>
        {label}
        {inputProps?.required === true && (
          <span className="text-red-500 ml-1">*</span>
        )}
      </Label>

      {inputProps?.formatDocument && (
        <a
          href={inputProps.formatDocument}
          download // ✅ triggers download
          className="text-theme-color hover:underline text-sm ml-2"
        >
          {language ? "(डाउनलोड प्रारूप)" : "(Download Format)"}
        </a>
      )}

      {inputProps?.description && (
        <div
          className="relative flex items-center"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onFocus={() => setShowTooltip(true)}
          onBlur={() => setShowTooltip(false)}
        >
          <InfoIcon
            className="w-4 h-4 text-gray-400 hover:text-blue-600 cursor-pointer"
            title="Info"
          />
          {showTooltip && (
            <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 z-20 w-64 p-2 bg-btn text-white text-xs rounded-md shadow-lg">
              {inputProps.description}
            </div>
          )}
        </div>
      )}
    </div>
  );

  if (inputProps.type === "checkbox") {
    return (
      <div className={`${divClass} flex items-center`}>
        <div className="flex flex-col w-full">
          <div className="flex items-center">
            <Input
              className="h-4 w-4 text-blue-600 border-gray-300 rounded"
              {...inputProps}
              language={language}
            />
            {renderLabel()}
          </div>
          {error && (
            <p className="text-red-500 text-sm mt-1">
              {typeof error === "object"
                ? language
                  ? error.hi
                  : error.en
                : error}
            </p>
          )}
        </div>
      </div>
    );
  }

  // default case
  return (
    <div className={divClass}>
      {renderLabel()}
      <Input className={inputClass} {...inputProps} language={language} />
      {error && (
        <p className="text-red-500 text-sm mt-1">
          {typeof error === "object" ? (language ? error.hi : error.en) : error}
        </p>
      )}
      {inputProps?.name && formData?.[`${inputProps.name}_in_words`] && (
        <p className="text-sm text-theme-color mt-1">
          {language
            ? formData[`${inputProps.name}_in_words`].hi
            : formData[`${inputProps.name}_in_words`].en}
        </p>
      )}
    </div>
  );
};

export default DataFormField;
